export default "<style>\r\n  \r\n  [data--invisible]\r\n  {\r\n    opacity: 0;  \r\n    display: none;\r\n  }\r\n\r\n</style>";